"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtlasEngineEventType = void 0;
/**
 * Contains definitions for all supported event types
 */
var AtlasEngineEventType;
(function (AtlasEngineEventType) {
    AtlasEngineEventType["OnEventProcessed"] = "OnEventProcessed";
    AtlasEngineEventType["OnProcessDeployed"] = "OnProcessDeployed";
    AtlasEngineEventType["OnProcessUndeployed"] = "OnProcessUndeployed";
    AtlasEngineEventType["OnProcessStarting"] = "OnProcessStarting";
    AtlasEngineEventType["OnProcessStarted"] = "OnProcessStarted";
    AtlasEngineEventType["OnProcessFinished"] = "OnProcessFinished";
    AtlasEngineEventType["onProcessError"] = "onProcessError";
    AtlasEngineEventType["OnProcessTerminated"] = "OnProcessTerminated";
    AtlasEngineEventType["OnProcessResumed"] = "OnProcessResumed";
    AtlasEngineEventType["OnFlowNodeEntered"] = "OnFlowNodeEntered";
    AtlasEngineEventType["OnFlowNodeCanceled"] = "OnFlowNodeCanceled";
    AtlasEngineEventType["OnFlowNodeExited"] = "OnFlowNodeExited";
    AtlasEngineEventType["OnFlowNodeSuspended"] = "OnFlowNodeSuspended";
    AtlasEngineEventType["OnFlowNodeResumed"] = "OnFlowNodeResumed";
    AtlasEngineEventType["OnFlowNodeError"] = "OnFlowNodeError";
    AtlasEngineEventType["OnFlowNodeTerminated"] = "OnFlowNodeTerminated";
    AtlasEngineEventType["OnFlowNodeCallActivityResponseReceived"] = "OnFlowNodeCallActivityResponseReceived";
    AtlasEngineEventType["OnFlowNodeEventSending"] = "OnFlowNodeEventSending";
    AtlasEngineEventType["OnFlowNodeEventRetrySending"] = "OnFlowNodeEventRetrySending";
    AtlasEngineEventType["OnFlowNodeEventResponseReceived"] = "OnFlowNodeEventResponseReceived";
    AtlasEngineEventType["OnFlowNodeTimerStarted"] = "OnFlowNodeTimerStarted";
    AtlasEngineEventType["OnFlowNodeTimerRemoved"] = "OnFlowNodeTimerRemoved";
})(AtlasEngineEventType = exports.AtlasEngineEventType || (exports.AtlasEngineEventType = {}));
//# sourceMappingURL=EngineEvent.js.map